import React, { createContext, useContext, useState, ReactNode } from "react";

// Define the shape of your state
interface QuestionNumbers {
	behavioralQuestionNo: number;
	technicalQuestionNo: number;
	codingQuestionNo: number;
}

// Define the context type
interface QuestionContextType {
	questionNumbers: QuestionNumbers;
	setQuestionNumbers: React.Dispatch<React.SetStateAction<QuestionNumbers>>;
}

// Create the context
const QuestionContext = createContext<QuestionContextType | undefined>(
	undefined
);

// Context Provider component
export const QuestionProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [questionNumbers, setQuestionNumbers] = useState<QuestionNumbers>({
		behavioralQuestionNo: 1,
		technicalQuestionNo: 0,
		codingQuestionNo: 0,
	});

	return (
		<QuestionContext.Provider value={{ questionNumbers, setQuestionNumbers }}>
			{children}
		</QuestionContext.Provider>
	);
};

// Custom hook to use the context
export const useQuestionNumberContext = (): QuestionContextType => {
	const context = useContext(QuestionContext);
	if (!context) {
		throw new Error(
			"useQuestionContext must be used within a QuestionProvider"
		);
	}
	return context;
};
